import React from "react";
import PrivacyPolicy from "@/components/Pages/Public/PrivacyPolicy";

const PrivacyPolicyPage: React.FC = () => {
  return <PrivacyPolicy />;
};

export default PrivacyPolicyPage;
